import { Link } from 'react-router-dom';

import paths from '~/lib/paths';
import { readableSegmentType } from '~/lib/segments';

import EmptyCompany from './EmptyCompany.svg';
import EmptyPerson from './EmptyPerson.svg';
import styles from './styles';

const HELP_CENTER_URL =
  'https://help.clearbit.com/hc/en-us/articles/360023927853-Getting-started-with-Segments';

const SEGMENT_TYPE_COMPANY = 'Company';
const SEGMENT_TYPE_PERSON = 'Person';

const icons = {
  [SEGMENT_TYPE_COMPANY]: <EmptyCompany />,
  [SEGMENT_TYPE_PERSON]: <EmptyPerson />,
};

const EmptySegmentHeadline = ({ classes, segmentType }) => (
  <h1 className={classes.emptySegmentHeadline}>
    There are no {readableSegmentType(segmentType)} matching this segment.
  </h1>
);

const EmptySegmentPlaceholder = ({ segmentType, segmentId, classes }) => (
  <div className={classes.root}>
    {icons[segmentType]}
    <EmptySegmentHeadline segmentType={segmentType} classes={classes} />
    <p className={classes.text}>
      Try editing the conditions for this segment or head to our{' '}
      <a href={HELP_CENTER_URL} target="_blank" rel="noopener noreferrer">
        help center
      </a>{' '}
      to learn more.
    </p>
    <Link
      to={paths.segmentEdit(segmentType, segmentId)}
      className={classes.cta}>
      Edit segment
    </Link>
  </div>
);

EmptySegmentPlaceholder.propTypes = {
  segmentType: PropTypes.oneOf([SEGMENT_TYPE_COMPANY, SEGMENT_TYPE_PERSON]),
  segmentId: PropTypes.string,
};

export default withStyles(styles)(EmptySegmentPlaceholder);
